// Native deep merge implementation
export const deepMerge = (target, source) => {
  const isObject = (obj) => obj && typeof obj === 'object' && !Array.isArray(obj);

  if (!isObject(target) || !isObject(source)) {
    return source;
  }

  const result = { ...target };

  Object.keys(source).forEach((key) => {
    if (isObject(source[key])) {
      if (key in target) {
        result[key] = deepMerge(target[key], source[key]);
      } else {
        result[key] = { ...source[key] };
      }
    } else {
      result[key] = source[key];
    }
  });

  return result;
};
